var _module_exports = "\n<div class=\"tb-uppercase\" ng-if=\"item && parentCtl.types.id.nullUid === item.tenantId.id\" translate>widgets-bundle.system</div>\n";;
var path = '/widget/widgets-bundle-card.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;